<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Maccsbox result') }} #{{ log.id }}</h4>
    </div>
    <div class="modal-body">
      <h4>{{ _('Status') }}</h4>
      <p v-if="parseInt(log.code) === -91">{{ _('Maccsbox has not processed the request. Please wait.') }}</p>
      <p v-else>{{ log.description }}</p>
      <h4>{{ _('Request data') }}</h4>
      <div class="well">
        <code>
          {{ log.request }}
        </code>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-if="canResendRequest" v-on:click="resendRequest(log.id)"><i class="fas fa-redo"></i> {{ _('Resend request') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['log'],
  computed: {
    canResendRequest () {
      if (parseInt(this.log.code) === -91) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    resendRequest (id) {
      this.$emit('resendRequest', id)
    }
  }
}
</script>

<style scoped>
code {
  display: block;
  line-break: anywhere;
}
</style>